/* =====================================================================
 * Sunset PDP Pilot v11 (2026-06-07) — editor-native build
 * 1) Buy-row stepper drives the row's OWN hidden quantity input
 *    (.sunset-row-qty-input in buy-buttons.liquid) — the Quantity selector
 *    block is gone. Falls back to a stock Dawn qty input if present.
 * 2) Estimator is fully server-rendered by snippets/sunset-estimator.liquid,
 *    positioned below Add to Cart in snippets/buy-buttons.liquid. It is
 *    intentionally NOT wired to the quantity selector — it reports yardage
 *    only; the buyer sets quantity themselves.
 * 3) v11: mobile hero scroll-reveal REMOVED — product media renders
 *    stock Dawn with no height manipulation.
 * 4) Related-products carousel fallback driver.
 * ===================================================================== */
(function () {
  'use strict';

  if (window.__sunsetPdpPilot) return;
  window.__sunsetPdpPilot = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- 4. Related-products carousel fallback (delegated) ---------- */
  function slideStep(ul) {
    var slide = ul.querySelector('.slider__slide');
    if (!slide) return ul.clientWidth;
    var r = slide.getBoundingClientRect();
    var gap = parseFloat(getComputedStyle(ul).columnGap || getComputedStyle(ul).gap) || 16;
    return r.width + gap;
  }
  function updateCounter(ul) {
    var sc = ul.closest('slider-component');
    if (!sc) return;
    var cur = sc.querySelector('.slider-counter--current');
    if (!cur) return;
    var page = Math.round(ul.scrollLeft / slideStep(ul)) + 1;
    if (String(page) !== cur.textContent) cur.textContent = page;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('product-recommendations .slider-button') : null;
    if (!btn) return;
    var sc = btn.closest('slider-component');
    var ul = sc && sc.querySelector('.slider');
    if (!ul) return;
    var before = ul.scrollLeft;
    setTimeout(function () {
      if (Math.abs(ul.scrollLeft - before) > 2) return; /* native handler worked */
      var step = slideStep(ul);
      ul.scrollBy({ left: btn.getAttribute('name') === 'next' ? step : -step, behavior: 'smooth' });
    }, 220);
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.matches && t.matches('product-recommendations .slider')) {
      updateCounter(t);
    }
  }, true);

  ready(function () {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var qtyInput = info.querySelector('.sunset-row-qty-input') || info.querySelector('input.quantity__input');

    function setQty(n) {
      if (!qtyInput) return;
      var min = parseInt(qtyInput.getAttribute('min') || '1', 10) || 1;
      n = Math.max(min, n);
      qtyInput.value = n;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* ---------- 1. Wire the server-rendered buy row ---------- */
    var row = info.querySelector('.product-form__buttons.sunset-buy-row');
    if (row && qtyInput) {
      var stepper = row.querySelector('[data-sunset-row-qty]');
      var valEl = row.querySelector('.sunset-buy-row__qty-val');

      function syncVal() { if (valEl) valEl.textContent = qtyInput.value || '1'; }

      if (stepper) {
        stepper.addEventListener('click', function (e) {
          var b = e.target.closest('button');
          if (!b) return;
          e.preventDefault();
          if (b.dataset.act === 'minus') setQty((parseInt(qtyInput.value, 10) || 1) - 1);
          else if (b.dataset.act === 'plus') setQty((parseInt(qtyInput.value, 10) || 1) + 1);
          syncVal();
        });
      }
      qtyInput.addEventListener('change', syncVal);
      qtyInput.addEventListener('input', syncVal);
      syncVal();

      /* Activate row layout (hides stock stepper + breakdown total bar) */
      document.documentElement.classList.add('sunset-v3');
    }

  });
})();
